import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5499_9767)">
      <mask
        id="mask0_5499_9767"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_5499_9767)">
        <path
          d="M12 24C5.37277 24 0 18.6273 0 12C0 5.37277 5.37277 0 12 0C18.6273 0 24 5.37277 24 12C24 18.6273 18.6285 24 12 24Z"
          fill="#FE5161"
        />
        <path
          d="M12.0547 5.5636C7.87252 5.5636 6.21826 8.11944 6.21826 11.8828C6.21826 15.6461 7.87252 18.3272 12.0547 18.3272C16.237 18.3272 17.891 15.6459 17.891 11.8828C17.891 8.11963 16.237 5.5636 12.0547 5.5636ZM12.0553 16.2649C10.1478 16.2649 9.15982 15.1455 8.86162 13.2615C8.83916 13.1195 8.94779 12.9904 9.09108 12.9904H14.99C15.1328 12.9904 15.2414 13.1187 15.2198 13.2605C14.9297 15.1451 13.9634 16.2649 12.0555 16.2649H12.0553ZM9.0663 10.9475C8.92513 10.9475 8.81728 10.822 8.83626 10.6813C9.10077 8.72201 10.0901 7.62602 12.0553 7.62602C14.0206 7.62602 14.9872 8.7224 15.2439 10.6823C15.2623 10.8226 15.1547 10.9475 15.0137 10.9475H9.0663Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_5499_9767">
        <rect width="24" height="24" rx="4" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
